<app-splash *ngIf="this.global.splashActive==true" [id]="this.global.idNotic" [account]="this.selectBan" [contentSplash]="this.global.contentSplash" [optionTemplete]="this.global.optionTemplete"></app-splash>
<div id="wrapper">
  <div>
      <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.showUserMobile"></app-menu>
  </div>
  <div class="table">
      <app-tab-nav (updateType)="this.type=$event"
      (updatePostpaid)="this.postpago=$event"
      (updatePrepaid)="this.prepago=$event"
      (updateFixed)="this.telefoniaFijo=$event"
      (updateTotalAccountList)="this.totalAccountList=$event"
      (updateCurrentList)="this.currentList=$event"
      (updateSelectBan)="this.selectBan=$event"
      (updateInitializeData)="this.initializeData()"></app-tab-nav>
  </div>
  <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
  <div class="table margin-topP" *ngIf="this.totalAccountList > 0">
    <div class="allcont">
      <app-postpaid *ngIf="this.postpago==true"
      [(cr)]="this.cr"
      [(accountType)]="this.accountType"
      [(accountSubtype)]="this.accountSubtype"
      [(currentList)]="this.currentList"
      [(billDueDateField)]="this.billDueDateField"
      [(billDateField)]="this.billDateField"
      [(lastPaymentAmountField)]="this.lastPaymentAmountField"
      [(billBalanceField)]="this.billBalanceField"
      [(paperless)]="this.paperless"
      (updateinitializeData)="this.initializeData()"
      ></app-postpaid>
      <app-prepaid *ngIf="this.prepago==true"
      [(subscribers)]="this.subscribers"
      [(subscriber)]="this.subscriber"
      [(accountType)]="this.accountType"
      [(accountSubtype)]="this.accountSubtype"
      [(currentList)]="this.currentList"
      [(billBalanceField)]="this.billBalanceField"
      [(endDateField)]="this.endDateField"
      (updateinitializeData)="this.initializeData()"
      ></app-prepaid>
      <app-fixed *ngIf="this.telefoniaFijo==true"
      [(cr)]="this.cr"
      [(accountType)]="this.accountType"
      [(accountSubtype)]="this.accountSubtype"
      [(currentList)]="this.currentList"
      [(billDueDateField)]="this.billDueDateField"
      [(billDateField)]="this.billDateField"
      [(lastPaymentAmountField)]="this.lastPaymentAmountField"
      [(billBalanceField)]="this.billBalanceField"
      [(paperless)]="this.paperless"
      (updateinitializeData)="this.initializeData()"
      ></app-fixed>
      <div class="basicrow lessm" *ngIf="this.postpago==true || this.telefoniaFijo==true">
        <div class="container">
          <div class="block-paperless">
              <div class="block-paperless-1">
                <app-paperless-module [paperless]="this.paperless" [viewPaper]="this.viewPaper"></app-paperless-module>
              </div>
              <div class="block-paperless-2">
                  <app-banner-chat></app-banner-chat>
              </div>
            </div>
        </div>
      </div>
      <div class="basicrow lessm" style="padding-bottom: 20px;">
        <div class="container">
          <app-ext-nav [(type)]="this.type"></app-ext-nav>
        </div>
      </div>
      <div class="basicrow lessm">
          <app-banner-home [(type)]="this.type"></app-banner-home>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>